// extracted by mini-css-extract-plugin
export default {"description":"DrawerDescription_description__e5hqG"};